import React, { useState, useEffect } from 'react';
import CommonCheckbox from '../../../../common/components/CommonCheckBox/CommonCheckbox';
import { useFormikContext } from 'formik';
import { getOtherSavings } from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import { ThrowError } from '../../../../common/constants/ThrowError';

const OtherSaving = () => {
  const [leadAppicant_Id, setLeadApplicant_Id] = useState('');
  const [lead_Id, setLead_id] = useState('');

  const {
    values: data,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm,
    resetForm
  } = useFormikContext();
  // get api
  useEffect(() => {
    if (lead_Id && leadAppicant_Id) {
      getOtherSavings(lead_Id, leadAppicant_Id)
        .then(res => {
          if (Object.keys(res).length !== 0) {
            setFieldValue('gold', res.gold);
            setFieldValue('mutualFunds', res.mutual_fund);
            setFieldValue('pF', res.pf);
            setFieldValue('fD', res.fd_rd);
            setFieldValue('uL', res.ul_ip);
            setFieldValue('fA', res.fixed_assets);
          }
        })
        .catch(err => {});
    }
  }, [lead_Id, leadAppicant_Id]);

  // fetching the leadDetails
  useEffect(() => {
    let leadDetails = getApplicantionInfo();
    const { leadId, leadApplicantId } = leadDetails;
    setLead_id(leadId);
    setLeadApplicant_Id(leadApplicantId);
  }, []);

  return (
    <>
      <div id="outerCon" className=" relative pb-12 ">
        <p className="font-normal font-roboto text-black-100 text-base ml-12">
          Other Savings
        </p>

        <div className="flex flex-col flex-start ml-12 content-around">
          <div className="inline-flex my-2 ">
            <CommonCheckbox
              checked={data?.gold || false}
              name="gold"
              value={data.gold}
              onChange={e => {
                // setchvalue(e.target.checked);
                setFieldValue('gold', e.target.checked, true);
                setFieldTouched('gold', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">Gold</p>
          </div>
          {/* bank Interest */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.mutualFunds || false}
              name="mutualFunds"
              value={data.mutualFunds}
              onChange={e => {
                // setchvalue(e.target.checked);
                setFieldValue('mutualFunds', e.target.checked, true);
                setFieldTouched('mutualFunds', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">Mutual Funds</p>
          </div>
          {/* rental agreement */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.pF || false}
              name="pF"
              value={data.pF}
              onChange={e => {
                // setchvalue(e.target.checked);
                setFieldValue('pF', e.target.checked, true);
                setFieldTouched('pF', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">PF</p>
          </div>
          {/* agriculture income */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.fD || false}
              name="fD"
              value={data.fD}
              onChange={e => {
                // setchvalue(e.target.checked);
                setFieldValue('fD', e.target.checked, true);
                setFieldTouched('fD', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">FD/RD </p>
          </div>
          {/* uL */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.uL || false}
              name="uL"
              value={data.uL}
              onChange={e => {
                // setchvalue(e.target.checked);
                setFieldValue('uL', e.target.checked, true);
                setFieldTouched('uL', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">UL/IP</p>
          </div>

          {/* fA */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.fA || false}
              name="fA"
              value={data.fA}
              onChange={e => {
                // setchvalue(e.target.checked);
                setFieldValue('fA', e.target.checked, true);
                setFieldTouched('fA', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">Fixed Assets</p>
          </div>
        </div>
      </div>

      <div className="mt-5 ">
        <button
          disabled={
            !(
              data.gold ||
              data.mutualFunds ||
              data.pF ||
              data.fD ||
              data.uL ||
              data.fA
            )
          }
          type="submit"
          className=" submitButton text-14 w-56 h-12 font-medium  font-roboto"
        >
          next
        </button>
        {<ThrowError />}
      </div>
    </>
  );
};
export default OtherSaving;
